import UserApi from "@/scripts/api/user.api";
import Global from "@/scripts/Global";
import ChannelApi from "@/scripts/api/channel.api";
import router from "@/router";
import { CPUtils } from "@/scripts/Utils";
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'PublicContact',
    data (){
        return {
            user: {
                username:'',
                email: '',
                password: '',
            },
            contact_name : "",
            error_message: "",
            loading: false,
            accept_agb:false,
            accept_data:false,
            username_error: false,
            email_error: false,
            isInvitationChannelLink: false,
            isInvitationUserLink: false,          
            session_id: '',
            contact_id: '',
        }
      },      
  mounted(){   
    Global.removeAllCookiesExcept(['login_token', 'login_email', 'rememberPW'], true)           
    this.contact_id = this.$route.params.pathMatch 
    if(typeof this.$route.query.c != 'undefined'){
        this.contact_name =  this.$route.query.n
        this.isInvitationChannelLink = true
        this.channel_id = this.$route.query.c
    } 

    if(typeof this.$route.query.u != 'undefined'){
        this.isInvitationUserLink = true
        this.contact_name =  this.$route.query.u
    }           
  },
  methods: { 
    GetPortalURL(){
        return Global.GetPortalURL()
      },  
    ContactRegister(){
        this.Validate("username")
        this.Validate("email")
        this.loading = true
        if(this.accept_agb && this.accept_data && !this.username_error && !this.email_error){
          if(this.isInvitationUserLink){
            // try to register the user
            UserApi.Register(this.user.email, this.user.username).then(res => {
              if(res.data.result){
                this.session_id = res.data.session_id
                this.publicUserContact()
              }else {
                if(res.data.reason == "user_already_exists"){
                  this.loading = false
                  this.user.password = ''                  
                  router.push({path: 'confirmpassword/', query: {u: this.contact_name, e : this.user.email} })
                  
                  // then go to steps for exists users 
                }
              }
            })
          }
          if(this.isInvitationChannelLink){
            // try to register the user
            UserApi.Register(this.user.email, this.user.username).then(res => {
              if(res.data.result){
                this.session_id = res.data.session_id
                this.publicChannelContact()
              }else {
                if(res.data.reason == "user_already_exists"){
                  this.loading = false
                  this.user.password = ''
                  router.push({name: 'confirmpassword/'+this.contact_id , query: {n: this.contact_name} })
                }
              }
            })
          }
        }else {      
          if(this.username_error){
            this.error_message = "Please choose a username"
          }else if (this.email_error){
            this.error_message = "Please enter an email"          
          }else {
            this.error_message = "Please confirm the privacy statement, terms and conditions"
          }        
          this.loading = false
        }
      },
      Validate(type){
        if(type == 'username'){
          if(!CPUtils.ValidateUsername(this.user.username) || this.user.username.length == 0){
            this.username_error = true
            this.error_message = "Please choose username, Username can't contain Special charachters like @  / \\ . $ or space"          
          }else {
            this.username_error = false
            this.error_message = ''
          }        
        }
  
        if(type == 'email'){
          if(this.user.email.length == 0){
            this.email_error = true
            this.error_message = "Please enter an email"          
          }else {
            this.email_error = false
            this.error_message = ''
          }        
        }
  
        this.mainSpinner = false
      },
      publicUserContact(){
        UserApi.RegisterByPublicContact(this.contact_name, this.session_id).then(res => {
          if(res.data.result){
            Global.setSessionID(this.session_id)      
            Global.globalValue(VueSignals.AUTHENTICATED, true)
            Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
            Global.globalValue(VueSignals.SESSION_ID, this.session_id)
            Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel.channel_id)
          }else {
                if(res.data.reason == "user_not_found"){              
                  this.error_message = "User is not exist"
                }
  
                if(res.data.reason == "user_not_public"){              
                  this.error_message = "The mentioned user is blocking the public chat"
                }
  
                if(res.data.reason == "channel_already_exists"){              
                  Global.setSessionID(this.session_id)      
                  Global.globalValue(VueSignals.AUTHENTICATED, true)
                  Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                  Global.globalValue(VueSignals.SESSION_ID, this.session_id)
                  Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel_id)
                }                
          }
        })
      },
      publicChannelContact(){
        ChannelApi.RegisterByPublicContact(this.channel_id, this.session_id).then(res => {
          if(res.data.result){
            Global.setSessionID(this.session_id)      
            Global.globalValue(VueSignals.AUTHENTICATED, true)
            Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
            Global.globalValue(VueSignals.SESSION_ID, this.session_id)
            Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel.channel_id)
          }else {
                if(res.data.reason == "channel_not_found"){              
                  this.error_message = "Channel is not exist"
                }
  
                if(res.data.reason == "channel_not_public"){              
                  this.error_message = "The mentioned channel is blocking the public join"
                }
  
                if(res.data.reason == "channel_already_exists"){              
                  Global.setSessionID(this.session_id)      
                  Global.globalValue(VueSignals.AUTHENTICATED, true)
                  Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                  Global.globalValue(VueSignals.SESSION_ID, this.session_id)
                  Global.globalValue(VueSignals.EXTERNAL_USER_JOIN, res.data.channel_id)
                }                
          }
        })
      },
      Login(){
          router.push('login')
      }
  }
}
